import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahKorwil, getAllKorwil, getAllClient } from "stores";
import { penempatanKorwil } from "stores";
import { editStatusKorwil } from "stores";
import { resetPassword } from "stores";
import { Dna } from "react-loader-spinner";
import { settingMenuKorwil } from "stores";

function ListKorwil() {
  const dispatch = useDispatch();
  const korwil = useSelector((state) => state.korwilReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalKorwil, setModalKorwil] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [nik, setNik] = React.useState("");
  const [role, setRole] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [listKorwil, setListKorwil] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [idKoordinatorWilayah, setIdKoordinatorWilayah] = React.useState("");
  const [filterClient, setFilterClient] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [modalSettingMenu, setModalSettingMenu] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const hasilFilterClient = (idClient) => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    let tmpFilter = listClient.filter((currentValue, index, arr) => {
      return currentValue.value === idClient;
    });
    tmp.push(tmpFilter[0]);
    setFilterClient(tmp);
  };

  const submitKorwil = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahKorwil({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllKorwil(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const submitSettingMenu = () => {
    const dataToSend = {
      idKorwil: idKoordinatorWilayah,
      menu: multipleSelect.map((option) => option.value),
    };
    settingMenuKorwil(dataToSend)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllKorwil(dispatch, { idClient: "" });
          setModalSettingMenu(false);
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusKorwil({
      idKorwil: idKoordinatorWilayah,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllKorwil(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihClient === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Client tidak boleh kosong",
      });
    } else {
      // const selectedCities = multipleSelect.map((option) => option.value);
      penempatanKorwil({
        idKoordinatorWilayah: idKoordinatorWilayah,
        idClient: idClient,
        // selectedCities: selectedCities
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setModalPenempatan(false);
          // setIdClient("");
          // setPilihClient("");
          getAllKorwil(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihClient(null);
    setModalKorwil(false);
    setModalPenempatan(false);
    setIdClient("");
    setPilihClient(null);
    setNik("");
    setNopeg("");
    setNama("");
  };

  // const submitResetPassword = async (data) => {
  //   try {
  //     const response = await resetPassword({
  //       idUser: data.idUser,
  //       role: data.role,
  //     });

  //     Swal.fire({
  //       title: "Sukses",
  //       text: response.data.message,
  //       icon: "success",
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error",
  //       text: error.response.data.message,
  //       icon: "error",
  //     });
  //   }
  // };

  React.useEffect(() => {
    let tmp =
      korwil.listKorwil &&
      korwil.listKorwil.map((val) => {
        return {
          ...val,
          action: (
            <div
              className="d-flex align-items-center flex-wrap"
              style={{ gap: "8px" }}
            >
              {auth.role === "super admin" || auth.role === "admin" ? (
                <>
                  {/* TOMBOL PENEMPATAN KORWIL */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-map-${val._id}`}>
                        Penempatan Korwil
                      </Tooltip>
                    }
                  >
                    <Button
                      disabled={val.status !== "aktif"}
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor:
                          val.status === "tidak aktif" ? "#cbd5e1" : "#447DF7",
                        color: "white",
                        cursor:
                          val.status === "tidak aktif"
                            ? "not-allowed"
                            : "pointer",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        hasilFilterClient(val.idClient);
                        setIdKoordinatorWilayah(val._id);
                        getAllClient(dispatch, { idClient: val.idClient });
                        setModalPenempatan(!modalPenempatan);
                      }}
                      onMouseOver={(e) => {
                        if (val.status === "aktif")
                          e.currentTarget.style.transform = "translateY(-2px)";
                      }}
                      onMouseOut={(e) => {
                        if (val.status === "aktif")
                          e.currentTarget.style.transform = "translateY(0)";
                      }}
                    >
                      <i
                        className="fas fa-map-marked-alt"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL EDIT STATUS */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-edit-${val._id}`}>
                        Edit Status
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#10b981", // Emerald Green
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={() => {
                        setIdKoordinatorWilayah(val._id);
                        setModalEdit(!modalEdit);
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-edit"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>

                  {/* TOMBOL RESET PASSWORD */}
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-reset-${val._id}`}>
                        Reset Password
                      </Tooltip>
                    }
                  >
                    <Button
                      className="d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        marginTop: 5,
                        width: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: "none",
                        backgroundColor: "#f90203", // Merah BPR Jatim
                        color: "white",
                        transition: "all 0.2s ease",
                      }}
                      onClick={async () => {
                        const result = await Swal.fire({
                          title: "Reset Password",
                          text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#2e3192", // Biru BPR Jatim
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Ya, Reset Password!",
                        });

                        if (result.isConfirmed) {
                          try {
                            const response = await resetPassword({
                              idUser: val._id,
                              role: val.role,
                            });
                            Swal.fire({
                              title: "Sukses",
                              text: response.data.message,
                              icon: "success",
                            });
                          } catch (error) {
                            Swal.fire({
                              title: "Error",
                              text: error.response.data.message,
                              icon: "error",
                            });
                          }
                        }
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      <i
                        className="fas fa-redo-alt"
                        style={{ fontSize: "16px" }}
                      ></i>
                    </Button>
                  </OverlayTrigger>
                </>
              ) : (
                <span className="text-muted fw-bold">—</span>
              )}

              {/* TOMBOL SETTING MENU (KHUSUS SUPER ADMIN) */}
              {auth.role === "super admin" && (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-setting-${val._id}`}>
                      Setting Menu
                    </Tooltip>
                  }
                >
                  <Button
                    className="d-flex align-items-center justify-content-center shadow-sm"
                    style={{
                      marginTop: 5,
                      width: "38px",
                      height: "38px",
                      borderRadius: "10px",
                      border: "none",
                      backgroundColor: "#2e3192", // Biru BPR Jatim
                      color: "white",
                      transition: "all 0.2s ease",
                    }}
                    onClick={() => {
                      setModalSettingMenu(!modalSettingMenu);
                      setIdKoordinatorWilayah(val._id);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "translateY(-2px)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    <i
                      className="fas fa-user-cog"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
    setListKorwil(tmp);
  }, [korwil.listKorwil, auth, modalEdit, modalPenempatan, modalSettingMenu]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru khas UI modern
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Paksa rata kiri
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "75px",
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Paksa rata kiri
        paddingLeft: "20px",
      },
    },
  };

  const colKorwil = [
    {
      name: "NO",
      width: "70px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted ml-1" style={{ fontSize: "14px" }}>
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "KOORDINATOR WILAYAH",
      minWidth: "280px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          {/* Avatar Inisial (Biru Jatim) */}
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg shadow-sm"
            style={{
              width: "42px",
              height: "42px",
              background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
              color: "white",
              fontSize: "16px",
              fontWeight: "900",
            }}
          >
            {row.nama.charAt(0).toUpperCase()}
          </div>
          <div>
            <span
              className="fw-900 text-dark d-block"
              style={{ fontSize: "16px", lineHeight: "1.2" }}
            >
              {row.nama}
            </span>
            <span className="text-muted fw-700" style={{ fontSize: "12px" }}>
              ID: {row.kodeUser} | {row.nopeg}
            </span>
          </div>
        </div>
      ),
    },
    {
      name: "PENEMPATAN",
      minWidth: "250px",
      center: false,
      cell: (row) => {
        const penempatan =
          row.penempatan.length === 0
            ? "Belum Penempatan"
            : row.penempatan[0].namaClient.namaClient;

        return (
          <div
            className="ml-1 px-3 py-1 rounded-pill bg-light border fw-800 text-dark"
            style={{ fontSize: "13px" }}
          >
            <i className="fas fa-university mr-2 text-primary"></i>
            {penempatan}
          </div>
        );
      },
    },
    {
      name: "STATUS",
      minWidth: "180px",
      center: false,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const isAktif = row.status === "aktif";

        return (
          <div
            className="ml-1 d-flex align-items-center justify-content-center"
            style={{
              fontWeight: "800",
              backgroundColor: isAktif ? "#dcfce7" : "#fee2e2",
              color: isAktif ? "#15803d" : "#b91c1c",
              padding: "8px 16px",
              borderRadius: "50px",
              fontSize: "12px",
              minWidth: "110px",
              textTransform: "uppercase",
            }}
          >
            <span
              className={`mr-2 status-dot ${isAktif ? "bg-success" : "bg-danger"}`}
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>
            {isAktif ? "Aktif" : "Non-Aktif"}
          </div>
        );
      },
    },
    {
      name: "AKSI",
      minWidth: "350px",
      center: false,
      omit: !(auth.role === "super admin" || auth.role === "admin"),
      cell: (row) => (
        <div className="ml-1" style={{ transform: "scale(1.05)" }}>
          {row.action}
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    getAllKorwil(dispatch, { idClient: "" })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      <Modal
        size="md"
        show={modalSettingMenu}
        onHide={() => setModalSettingMenu(!modalSettingMenu)}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: "60px",
                height: "60px",
                backgroundColor: "#f0fdf4",
                borderRadius: "15px",
                color: "#2e3192",
              }}
            >
              <i
                className="fas fa-tasks fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h4 className="font-weight-bold m-0">SETTING MENU KORWIL</h4>
            <p className="text-muted small">
              Tentukan akses menu khusus koordinator
            </p>
          </div>

          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2">
              Pilih Daftar Menu
            </label>
            <Select
              className="react-select info shadow-sm"
              classNamePrefix="react-select"
              isMulti
              value={multipleSelect}
              onChange={(value) => setMultipleSelect(value)}
              options={[
                { value: "Dashboard", label: "Dashboard" },
                { value: "Client", label: "Client" },
                { value: "User", label: "User" },
                { value: "Cabang", label: "Cabang" },
                { value: "Target", label: "Target" },
                { value: "Pengajuan", label: "Pengajuan" },
                { value: "Pencairan", label: "Pencairan" },
                { value: "Kunjungan", label: "Kunjungan" },
              ]}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                }),
              }}
            />
          </Form.Group>

          <Button
            className="btn-block py-3 mt-4 border-0 shadow-sm fw-900"
            style={{
              background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={submitSettingMenu}
          >
            SIMPAN AKSES MENU
          </Button>
        </Modal.Body>
      </Modal>

      {/* MODAL PENEMPATAN KORWIL */}
      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        contentClassName="border-0 shadow-lg"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              className="p-3 d-inline-block mb-3"
              style={{ background: "#eef2ff", borderRadius: "15px" }}
            >
              <i
                className="fas fa-map-marker-alt fa-2x text-primary"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h4 className="font-weight-bold m-0">PENEMPATAN KORWIL</h4>
            <p className="text-muted small">
              Tentukan wilayah tugas koordinator ini
            </p>
          </div>

          <Form.Group>
            <label className="small fw-800 text-muted text-uppercase mb-2">
              Pilih Client / BPD
            </label>
            <Select
              className="react-select primary shadow-sm"
              classNamePrefix="react-select"
              value={pilihClient}
              onChange={(value) => {
                setPilihClient(value);
                setIdClient(value.value);
              }}
              options={filterClient}
              placeholder="Pilih Client"
              styles={{
                control: (base) => ({ ...base, borderRadius: "12px" }),
              }}
            />
          </Form.Group>

          <Button
            className="btn-block py-3 mt-4 border-0 fw-900 shadow-sm"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={submitPenempatan}
          >
            SUBMIT PENEMPATAN
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalKorwil}
        onHide={() => {
          handleModalClose();
          setModalKorwil(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                borderRadius: "15px",
              }}
            >
              <i
                className="fas fa-user-plus text-white fa-lg"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold" style={{ color: "#1e293b" }}>
                TAMBAH KORWIL
              </h3>
              <p className="m-0 text-muted">
                Input data Koordinator Wilayah baru BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Row>
              <Col md="12">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    NIK (Nomor Induk Kependudukan)
                  </label>
                  <div
                    className="d-flex align-items-center bg-light rounded-lg px-3 border shadow-sm"
                    style={{ height: "55px" }}
                  >
                    <Form.Control
                      className="border-0 bg-transparent p-0 fw-700"
                      onChange={handleNikChange}
                      value={nik}
                      type="text"
                      placeholder="Masukkan 16 Digit NIK"
                      style={{ fontSize: "16px" }}
                    />
                    <span
                      className={`badge ${remainingDigits === 0 ? "badge-success" : "badge-warning"} py-2 px-3`}
                      style={{ borderRadius: "8px" }}
                    >
                      {remainingDigits} Digit
                    </span>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Lengkap Korwil
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light"
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      fontWeight: "600",
                    }}
                    placeholder="Contoh: Budi Santoso"
                    type="text"
                    onChange={(e) => setNama(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nomor Karyawan
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light"
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      fontWeight: "600",
                    }}
                    placeholder="Contoh: 2024001"
                    type="text"
                    onChange={(e) => setNopeg(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {auth.role === "super admin" && (
              <Row>
                <Col md="12">
                  <Form.Group className="mb-3">
                    <label className="small fw-800 text-dark text-uppercase">
                      Pilih Penempatan Client
                    </label>
                    <Select
                      className="react-select primary border-0"
                      classNamePrefix="react-select"
                      value={pilihClient}
                      onChange={(value) => {
                        setPilihClient(value);
                        setIdClient(value.value);
                      }}
                      options={listClient}
                      placeholder="Pilih Client Penempatan"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "12px",
                          minHeight: "50px",
                          border: "1px solid #e2e8f0",
                        }),
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* FOOTER BUTTONS: STACKED FOR PERFECTION */}
            <div className="mt-4 pt-2">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitKorwil}
              >
                SIMPAN DATA KORWIL
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none"
                style={{ fontSize: "14px" }}
                onClick={() => {
                  handleModalClose();
                  setModalKorwil(false);
                }}
              >
                Batalkan & Keluar
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm" // Ukuran kecil lebih pas dan elegan untuk edit status
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(!modalEdit);
        }}
        centered
        contentClassName="border-0 shadow-lg"
        style={{ backdropFilter: "blur(4px)" }}
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-4 pb-4 text-center">
          {/* Ikon Indikator Status */}
          <div className="mb-3">
            <div
              className="d-inline-flex align-items-center justify-content-center"
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#f8fafc",
                borderRadius: "50%",
                color: "#2e3192",
                border: "2px dashed #e2e8f0",
              }}
            >
              <i
                className="fas fa-user-check fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
          </div>

          <h4 className="font-weight-bold mb-1" style={{ color: "#1e293b" }}>
            EDIT STATUS
          </h4>
          <p className="text-muted small mb-4">
            Ubah status keaktifan Koordinator Wilayah
          </p>

          <Form>
            <Form.Group className="text-left">
              <label className="small fw-800 text-muted text-uppercase mb-2 d-block">
                Pilih Status Baru
              </label>
              <Select
                className="react-select primary shadow-sm"
                classNamePrefix="react-select"
                name="singleSelect"
                value={status}
                onChange={(selectedOption) => setStatus(selectedOption)}
                options={[
                  { value: "true", label: "✅ AKTIF" },
                  { value: "false", label: "❌ TIDAK AKTIF" },
                ]}
                placeholder="-- Pilih Status --"
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "12px",
                    height: "45px",
                    fontWeight: "700",
                  }),
                }}
              />
            </Form.Group>

            {/* Tombol Stacked (Sesuai gaya BPR Jatim) */}
            <div className="mt-4">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-sm"
                style={{
                  background: "#2e3192", // Biru Utama Jatim
                  borderRadius: "12px",
                  color: "white",
                  fontSize: "14px",
                  letterSpacing: "1px",
                }}
                onClick={checkStatus}
              >
                UPDATE STATUS
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 text-muted fw-700 text-decoration-none small"
                onClick={() => setModalEdit(false)}
              >
                Batal
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content>
        {/* AREA ACTION & SEARCH (STYLE BPR JATIM) */}
        <div className="px-4 py-2 bg-white">
          <Row className="align-items-center justify-content-between">
            {/* Kolom Tombol Tambah */}
            <Col md="5" xs="12" className="mb-3 mb-md-0">
              {auth.role === "super admin" || auth.role === "admin" ? (
                <Button
                  className="btn-fill btn-wd d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    marginTop: "10px",
                    background:
                      "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)",
                    fontWeight: "900",
                    border: 0,
                    borderRadius: "12px",
                    padding: "10px 25px",
                    fontSize: "13px",
                    letterSpacing: "0.5px",
                  }}
                  onClick={() => setModalKorwil(!modalKorwil)}
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  TAMBAH KOORDINATOR WILAYAH
                </Button>
              ) : null}
            </Col>

            {/* Kolom Search Bar */}
            <Col md="4" xs="12">
              <InputGroup
                className="shadow-none border rounded-lg"
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  backgroundColor: "#f8fafc",
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text className="bg-transparent border-0">
                    <i className="fas fa-search text-muted"></i>
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  className="border-0 bg-transparent fw-600"
                  style={{
                    paddingLeft: "5px",
                    height: "45px",
                    fontSize: "14px",
                  }}
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="No Karyawan / Nama Korwil..."
                />
              </InputGroup>
            </Col>
          </Row>
        </div>

        <hr className="mx-4 my-4" style={{ opacity: "0.05" }} />

        {/* AREA TABLE / LOADING STATE */}
        <div className="px-4 pb-4">
          {isLoading ? (
            <div
              className="loader-container d-flex flex-column align-items-center justify-content-center"
              style={{
                minHeight: "40vh",
                background: "#f8fafc",
                borderRadius: "20px",
              }}
            >
              <Dna
                visible={true}
                height="100"
                width="100"
                ariaLabel="dna-loading"
              />
              <h6
                className="mt-3 font-weight-bold text-muted"
                style={{ letterSpacing: "2px", fontSize: "12px" }}
              >
                MEMUAT DATA KORWIL...
              </h6>
            </div>
          ) : (
            <div className="table-responsive rounded-xl shadow-sm border">
              <DataTable
                columns={colKorwil}
                data={listKorwil.filter(
                  (row) =>
                    row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
                    row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
                )}
                customStyles={{
                  ...customStyles,
                  rows: {
                    style: {
                      minHeight: "70px",
                      "&:hover": {
                        backgroundColor: "#f1f5f9",
                        transition: "0.2s",
                      },
                    },
                  },
                }}
                pagination
                paginationPerPage={itemsPerPage}
                onChangePage={handlePageChange}
                highlightOnHover
              />
            </div>
          )}
        </div>

        <style>{`
    .fw-600 { font-weight: 600; }
    .rounded-xl { border-radius: 15px !important; overflow: hidden; }
    .btn-fill { transition: all 0.3s ease; }
    .btn-fill:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(249, 2, 3, 0.3) !important; }
    
    /* Fokus pada input search */
    .input-group:focus-within {
      border-color: #2e3192 !important;
      box-shadow: 0 0 0 0.2rem rgba(46, 49, 146, 0.1) !important;
    }
  `}</style>
      </Tab.Content>
    </>
  );
}

export default ListKorwil;
